import { createContext, useState } from 'react';

import TableData from './TableData';

export const TableStateContext = createContext();

const TableContextProvider = ({ children }) => {
  const stateHook = useState(TableData.INITIAL_TABLE_STATE);

  return (
    <TableStateContext.Provider value={stateHook}>
      {children}
    </TableStateContext.Provider>
  );
};

export default TableContextProvider;